@if(loader){
    <app-loader></app-loader>
}
<p-card header="">
    <p-dataView #dv [value]="storeConsumptionData" [layout]="layout">
        <ng-template let-storeConsumption pTemplate="list" let-storeConsumptions>

            <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
                <div class="flex align-items-center">
                    <p-button label="New" class="p-button-outlined" (click)="addStoreConsumption()"
                        icon="pi pi-plus-circle" size="small"></p-button>

                    <div class="flex align-items-center ml-3">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"
                                class="p-inputtext-sm" (keyup.enter)="searchStoreConsumption()"
                                style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" autocomplete="one-time-code"/>
                        </span>
                        <p-button icon="pi pi-search" (onClick)="searchStoreConsumption()" class="ml-2"
                            [ngStyle]="{ height: '35px' }" [raised]="true" [size]="'small'" severity="info"></p-button>
                    </div>
                    <p-button *ngIf="selectedStoreConsumptions && selectedStoreConsumptions.length == 1" label="Edit"
                        (click)="editStoreConsumption()" class="p-button-outlined ml-2" icon="pi pi-user-edit"
                        severity="secondary" size="small"></p-button>
                    <p-button *ngIf="selectedStoreConsumptions && selectedStoreConsumptions.length > 0" label="Delete"
                        (click)="deleteStoreConsumption()" class="p-button-outlined ml-2" icon="pi pi-trash"
                        severity="danger" size="small"></p-button>
                </div>

                <h2 class="page-title-center">Store Consumptions</h2>


                <div style="flex: 1; display: flex; justify-content: flex-end;">
                    <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true"
                        severity="info"></p-button>
                </div>
            </div>

            <p-table #dt1 [value]="storeConsumptionData" [scrollable]="true" scrollHeight="613px" 
                responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm" [paginator]="true"
                [loading]="loading" [rows]="10" [globalFilterFields]="['scCode', 'empName', 'fromDate', 'endDate']"
                (onPage)="onPageChange($event)" [(selection)]="selectedStoreConsumptions"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="[10, 15, 20]" [rowHover]="true" [selectionPageOnly]="true">

                <ng-template pTemplate="header">
                    <tr>
                        <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                        <th>SC Number</th>
                        <th>Employee Name</th>
                        <th>Project</th>
                        <th>{{unitLabel}} Name</th>
                        <th>From Date</th>
                        <th>End Date</th>
                        <!-- <th>Total Days</th>
                        <th>Total Labor Cost</th> -->
                        <th>Created By</th>
                        <th>Print</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-storeConsumption>
                    <tr>
                        <td><p-tableCheckbox [value]="storeConsumption"></p-tableCheckbox></td>
                        <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editStoreConsumption(storeConsumption)">
                            {{ storeConsumption.scCode }}
                        </td>
                        <td>{{ storeConsumption.empName }}</td>
                        <td>{{ storeConsumption.projectBoMName }}</td>
                        <td>{{ storeConsumption.warehouseCode }}</td>
                        <td>{{ storeConsumption.fromDate | date: 'dd/MM/yyyy' }}</td>
                        <td>{{ storeConsumption.endDate | date: 'dd/MM/yyyy' }}</td>
                        <!-- <td>{{ storeConsumption.totDays }}</td>
                        <td>₹ {{ (storeConsumption.totLaborCost || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td> -->
                        <td>{{ storeConsumption.createdBy }}</td>
                        <td><span class="pi pi-print" style="color: rgb(0 35 255); cursor: pointer;"
                            (click)="showReport(storeConsumption)"></span></td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8">No Records found.</td>
                    </tr>
                </ng-template>
            </p-table>
        </ng-template>
    </p-dataView>
</p-card>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
